// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICardStatusSummaryRecordDto
 */
export interface ICardStatusSummaryRecordDto {
    /**
     * 
     * @type {number}
     * @memberof ICardStatusSummaryRecordDto
     */
    total_active_cards?: number;
    /**
     * 
     * @type {number}
     * @memberof ICardStatusSummaryRecordDto
     */
    total_pending_activation_cards?: number;
    /**
     * 
     * @type {number}
     * @memberof ICardStatusSummaryRecordDto
     */
    total_closed_cards?: number;
    /**
     * 
     * @type {number}
     * @memberof ICardStatusSummaryRecordDto
     */
    total_lost_cards?: number;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusSummaryRecordDto
     */
    percentage_of_active_cards?: string;
    /**
     * 
     * @type {number}
     * @memberof ICardStatusSummaryRecordDto
     */
    primary_cards_number?: number;
    /**
     * 
     * @type {number}
     * @memberof ICardStatusSummaryRecordDto
     */
    dependent_cards_number?: number;
}

/**
 * Check if a given object implements the ICardStatusSummaryRecordDto interface.
 */
export function instanceOfICardStatusSummaryRecordDto(value: object): value is ICardStatusSummaryRecordDto {
    return true;
}

export function ICardStatusSummaryRecordDtoFromJSON(json: any): ICardStatusSummaryRecordDto {
    return ICardStatusSummaryRecordDtoFromJSONTyped(json, false);
}

export function ICardStatusSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardStatusSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_active_cards': json['total_active_cards'] == null ? undefined : json['total_active_cards'],
        'total_pending_activation_cards': json['total_pending_activation_cards'] == null ? undefined : json['total_pending_activation_cards'],
        'total_closed_cards': json['total_closed_cards'] == null ? undefined : json['total_closed_cards'],
        'total_lost_cards': json['total_lost_cards'] == null ? undefined : json['total_lost_cards'],
        'percentage_of_active_cards': json['percentage_of_active_cards'] == null ? undefined : json['percentage_of_active_cards'],
        'primary_cards_number': json['primary_cards_number'] == null ? undefined : json['primary_cards_number'],
        'dependent_cards_number': json['dependent_cards_number'] == null ? undefined : json['dependent_cards_number'],
    };
}

export function ICardStatusSummaryRecordDtoToJSON(json: any): ICardStatusSummaryRecordDto {
    return ICardStatusSummaryRecordDtoToJSONTyped(json, false);
}

export function ICardStatusSummaryRecordDtoToJSONTyped(value?: ICardStatusSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total_active_cards': value['total_active_cards'],
        'total_pending_activation_cards': value['total_pending_activation_cards'],
        'total_closed_cards': value['total_closed_cards'],
        'total_lost_cards': value['total_lost_cards'],
        'percentage_of_active_cards': value['percentage_of_active_cards'],
        'primary_cards_number': value['primary_cards_number'],
        'dependent_cards_number': value['dependent_cards_number'],
    };
}

